export default __webpack_public_path__ + "static/media/lip-2.cca58fcb.PNG";